export default {
  name: "PrintSVG",
  props: {
    fill: {
      type: String,
      default: "#FFA621"
    }
  }
};